import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { Input } from "../../common/components/Input";
import { spacing } from "../../styles/theme";
import { useSpecsEditorContextValue } from "./useSpecsEditor";

const RESOLUTION_OPTIONS = ["1K", "2K", "4K"];
const FORMAT_OPTIONS = ["png", "jpeg", "webp"];
const ASPECT_OPTIONS = ["1:1", "4:3", "3:4", "16:9", "9:16", "3:2", "2:3"];

export default function SpecsSettingsPage() {
  const {
    editor: { session, updateFalSettings },
  } = useSpecsEditorContextValue();

  return (
    <Paper variant="outlined" sx={{ p: spacing.groupingDesktop }}>
      <Typography variant="h2" sx={{ mb: 3 }}>
        Paramètres
      </Typography>

      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        fal.ai
      </Typography>
      <Input
        label="API Key"
        type="password"
        fullWidth
        noMaxWidth
        value={session.falSettings.apiKey}
        onChange={(e) => updateFalSettings({ apiKey: e.target.value })}
        containerSx={{ mb: 1.5 }}
      />

      <Stack direction="row" spacing={1} sx={{ mb: 1.5 }}>
        <FormControl variant="standard" size="small" fullWidth>
          <InputLabel>Resolution</InputLabel>
          <Select
            value={session.falSettings.resolution}
            onChange={(e) => updateFalSettings({ resolution: e.target.value })}
            disableUnderline
          >
            {RESOLUTION_OPTIONS.map((resolution) => (
              <MenuItem key={resolution} value={resolution}>
                {resolution}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" size="small" fullWidth>
          <InputLabel>Format</InputLabel>
          <Select
            value={session.falSettings.outputFormat}
            onChange={(e) =>
              updateFalSettings({ outputFormat: e.target.value })
            }
            disableUnderline
          >
            {FORMAT_OPTIONS.map((format) => (
              <MenuItem key={format} value={format}>
                {format}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <FormControl variant="standard" size="small" fullWidth>
        <InputLabel>Aspect Ratio</InputLabel>
        <Select
          value={session.falSettings.aspectRatio}
          onChange={(e) => updateFalSettings({ aspectRatio: e.target.value })}
          disableUnderline
        >
          {ASPECT_OPTIONS.map((aspectRatio) => (
            <MenuItem key={aspectRatio} value={aspectRatio}>
              {aspectRatio}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Paper>
  );
}
